import React from "react";
import Call from "../../../hocs/call";
import {connect} from "react-redux";
import ArtefactList from "../../../components/artefact-list";
import {
  deleteMsdsMsd,
  deleteMsdsSelectedMsds,
  hideMsdsMsdParentsAndChildren,
  readMsdsListMsds,
  readMsdsMsdParentsAndChildren,
  showMsdsMsdClone,
  showMsdsMsdDetail,
  showMsdsMsdDownload,
  showMsdsMsdExport,
  showMsdsMsdExportList
} from "./actions";
import { showArtefactFullExport } from "../../../redux-components/redux-artefact-full-export/actions";

const mapStateToProps = state => ({
  msds: state.scenes.metaManager.msds.msds,
  parentsAndChildren: state.scenes.metaManager.msds.parentsAndChildren
});

const mapDispatchToProps = dispatch => ({
  fetchMsds: () => dispatch(readMsdsListMsds()),
  onMsdShow: msdTriplet => dispatch(showMsdsMsdDetail(msdTriplet)),
  onDelete: msdTriplet => dispatch(deleteMsdsMsd(msdTriplet)),
  onSelectedMsdsDelete: msdTriplets => dispatch(deleteMsdsSelectedMsds(msdTriplets)),
  onDownloadShow: (msdTriplets, lang) => dispatch(showMsdsMsdDownload(msdTriplets, lang)),
  fetchParentsAndChildren: (artefactType, artefactTriplet) =>
    dispatch(readMsdsMsdParentsAndChildren(artefactType, artefactTriplet)),
  onParentsAndChildrenHide: () => dispatch(hideMsdsMsdParentsAndChildren()),
  onCloneShow: artefactTriplet => dispatch(showMsdsMsdClone(artefactTriplet)),
  onExportShow: sourceTriplet => dispatch(showMsdsMsdExport(sourceTriplet)),
  onExportShowList: artefactIdentity => dispatch(showArtefactFullExport(artefactIdentity)),
});

const MsdsList = ({
                    msds,
                    fetchMsds,
                    onMsdShow,
                    onDelete,
                    onSelectedMsdsDelete,
                    onDownloadShow,
                    parentsAndChildren,
                    fetchParentsAndChildren,
                    onParentsAndChildrenHide,
                    onCloneShow,
                    onExportShow,
                    onExportShowList
                  }) =>
  <Call cb={fetchMsds} disabled={msds !== null}>
    <ArtefactList
      artefacts={msds}
      onDetailShow={onMsdShow}
      onDownloadShow={onDownloadShow}
      onDelete={onDelete}
      onSelectedItemDelete={onSelectedMsdsDelete}
      parentsAndChildren={parentsAndChildren}
      fetchParentsAndChildren={triplet => fetchParentsAndChildren("metadatastructure", triplet)}
      onParentsAndChildrenHide={onParentsAndChildrenHide}
      showImportButton
      onCloneShow={onCloneShow}
      onExportShow={onExportShow}
      onExportShowList={onExportShowList}
    />
  </Call>;

export default connect(mapStateToProps, mapDispatchToProps)(MsdsList);
